import { GraduationCapIcon, LayersIcon, SmartphoneIcon, type LucideIcon } from 'lucide-react';

export interface Differentiator {
  icon: LucideIcon;
  title: string;
  text: string;
  bgClass: string;
  borderClass: string;
  iconClass: string;
}

export const differentiators: Differentiator[] = [
  {
    icon: GraduationCapIcon,
    title: 'Balonmano Base Real',
    text: 'Diseñado por entrenadores con años de experiencia en el balonmano base español. Para la realidad de la pista pequeña, los 12 chavales y el padre que grita desde la gradería.',
    bgClass: 'bg-azul-light',
    borderClass: 'border-azul',
    iconClass: 'text-azul'
  },
  {
    icon: LayersIcon,
    title: 'Todas las Categorías',
    text: 'Desde Alevín (8-10 años) hasta Juvenil y Amateur. Con adaptaciones específicas para categoría por edad y nivel de juego.',
    bgClass: 'bg-naranja-pale',
    borderClass: 'border-naranja',
    iconClass: 'text-naranja'
  },
  {
    icon: SmartphoneIcon,
    title: 'Multidispositivo',
    text: 'Tablet, móvil, PC o para imprimir — consúltalo desde el banquillo sin que nadie lo note. Acceso desde cualquier lugar.',
    bgClass: 'bg-azul-light',
    borderClass: 'border-azul',
    iconClass: 'text-azul'
  }
];
